import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Draggable } from 'react-beautiful-dnd'
import deepmerge from 'deepmerge'

import Box from '../../Box'

import ConfigurationOptions from './ConfigurationOptions'

import CustomizableDashboardContext from '../../../contexts/customizableDashboardContext'

import { shouldRender } from '../hooks/useDashboardModule'

const ModuleRenderer = (props) => {
  const { modules, parentId } = props

  const customizableDashboardContext = useContext(CustomizableDashboardContext)
  const {
    availableModules, callbacks, editing, loadedModules, moduleOptions,
  } = customizableDashboardContext

  return modules.map((moduleProps, index) => {
    const { key, moduleId } = moduleProps
    const {
      component, configOptions, mergeConfig, title,
    } = availableModules[moduleId] || {}

    if (!component) return null
    const Component = component

    // Merge Custom Module Options and Scope Options
    const customOptions = deepmerge({ ...moduleOptions[key] }, { ...mergeConfig })

    if (!shouldRender(key, editing, customOptions, loadedModules)){
      return null
    }

    return (
      <Draggable
        draggableId={key}
        isDragDisabled={!editing}
        key={key}
        index={index}
      >
        {provided => (
          <Box
            flexDirection="column"
            marginTop="large"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            {editing && (
              <ConfigurationOptions
                callbacks={callbacks}
                configOptions={configOptions}
                customOptions={customOptions}
                editing={editing}
                moduleKey={key}
                moduleTitle={title}
                parentId={parentId}
              />
            )}

            <Component
              customOptions={customOptions}
              editing={editing}
              moduleKey={key}
              parentId={parentId}
            />
          </Box>
        )}
      </Draggable>
    )
  })
}

ModuleRenderer.propTypes = {
  modules: PropTypes.array.isRequired,
}

export default ModuleRenderer
